<template>
    <v-card class="elevation-10 rounded-xl">
        <v-card-title style="background:#6499faff; color: white;">{{ $t('user.formTitle') }}</v-card-title>
        <v-divider class="mx-4" />
        <v-card-text>
            <v-form :readonly="readOnly">
                <v-row>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="user.name"
                            :label="$t('field.firstName')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="user.lastName"
                            :label="$t('field.lastName')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="user.mobile"
                            :label="$t('field.mobilePhone')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="user.email"
                            :label="$t('field.email')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="3">
                        <date-time-picker
                            :date-label="$t('field.birthday')"
                            :date="birthday"
                            @setDate="setBirthday"
                        />
                    </v-col>
                    <v-col cols="12">
                        {{ $t('user.addNote') }}
                        <v-btn icon color="primary" @click="addNote">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col v-for="(note, index) in user.notes" :key="`note-${index}`" cols="12">
                        <v-row align="center">
                            <v-col cols="1">
                                <v-btn icon color="primary" @click="removeNote(index)">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="10">
                                <note-form :note="note" />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        {{ $t('user.addMembership') }}
                        <v-btn icon color="primary" @click="addMembership">
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col v-for="(membership, index) in user.userMemberships" :key="`userMembership-${index}`" cols="12">
                        <v-row align="center">
                            <v-col cols="1">
                                <v-btn icon color="primary" @click="removeMembership(index)">
                                    <v-icon>mdi-minus-circle</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col cols="10">
                                <user-membership-form :user-membership="membership" />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn :loading="loading" class="mx-2 white--text" :disabled="shouldDisableSubmit()" large color="black" @click="onSubmit">
                {{ $t('button.submit') }}
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                {{ $t('button.cancel') }}
            </v-btn>
        </v-card-actions>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-card>
</template>

<script>
    import userService from '@/services/user'
    import userMembershipService from '@/services/userMembership'
    import Alert from '@/components/Alert'
    import DateTimePicker from '@/components/DateTimePicker'
    import momentTimezone from 'moment-timezone'
    import NoteForm from '@/forms/NoteForm'
    import UserMembershipForm from '@/forms/UserMembershipForm'

    export default {
        name: 'UserForm',
        components: { Alert, DateTimePicker, NoteForm, UserMembershipForm },
        data: () => {
            return {
                showAlert: false,
                dialog: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                birthday: null,
                user: { notes: [], userMemberships: [] },
                mandatoryField: [
                    v => !!v || 'Field is required'
                ],
                search: null
            }
        },
        computed: {
        },
        watch: {
            search() {
                if (this.search.length > 0) {
                    this.fetchFilteredUsers()
                }
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            if (this.$route.params.userId) {
                this.fetchUser(this.$route.params.userId)
            }
        },
        methods: {
            normalizeUser(user) {
                return {
                    ...user,
                    notes: Array.isArray(user && user.notes) ? user.notes : [],
                    userMemberships: Array.isArray(user && user.userMemberships) ? user.userMemberships : []
                }
            },
            fetchUser(userId) {
                userService.getUser(userId).then(resp => {
                    this.user = this.normalizeUser(resp.data)
                    this.fetchUserMemberships(userId)
                    this.birthday = this.user.birthday
                        ? momentTimezone(this.user.birthday, 'DD/MM/YYYY').tz('Europe/Athens').format('YYYY-MM-DD').toString()
                        : null
                })
            },
            fetchUserMemberships(userId) {
                userMembershipService.getMemberships({ 'userId': userId }).then(resp => {
                    const memberships = resp.data && resp.data.content ? resp.data.content : (Array.isArray(resp.data) ? resp.data : [])
                    this.$set(this.user, 'userMemberships', memberships)
                })
            },
            updateUser() {
                this.dialog = false
                this.fetchUser(this.$route.params.userId)
            },
            openDialog(data) {
                this.dialog = true
            },
            getCoachText(item) {
                return `${item.name} ${item.lastName}`
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return false
            },
            setStartDate(date) {
                this.startDate = date
            },
            setEndDate(date) {
                this.endDate = date
            },
            onEdit() {
                this.$router.push(`/users/${this.user.id}/edit`)
            },
            createUser() {
                userService.createUser(this.user).then(userResponse => {
                    this.loading = false
                    this.$router.push(`/users`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editUser() {
                userService.updateUser(this.$route.params.userId, this.user).then(userResponse => {
                    this.loading = false
                    this.$router.push(`/users`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            async onSubmit() {
                this.loading = true
                if (this.birthday) {
                    this.user.birthday = momentTimezone(this.birthday).tz('Europe/Athens').format('DD/MM/YYYY').toString()
                }
                if (this.mode === 'edit') {
                    this.editUser()
                } else if (this.mode === 'create') {
                    this.createUser()
                } else {
                    this.createUser()
                }
            },
            setBirthday(date) {
                this.birthday = momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            addNote() {
                if (!Array.isArray(this.user.notes)) this.$set(this.user, 'notes', [])
                this.user.notes.push({ note: '' })
            },
            removeNote(idx) {
                if (!this.user.notes) return
                if (idx !== -1) this.user.notes.splice(idx, 1)
            },
            addMembership() {
                if (!Array.isArray(this.user.userMemberships)) this.$set(this.user, 'userMemberships', [])
                this.user.userMemberships.push({})
            },
            removeMembership(idx) {
                if (!this.user.userMemberships) return
                if (idx !== -1) this.user.userMemberships.splice(idx, 1)
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
